import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./components/new-navbar";
import logo from "./routes/navbar/logo.png";
import AnimatedGradient from "./components/animated-gradient";
import Footer from "./components/new-footer";
import { useTranslation } from "./i18n";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./components/dialog";
import { Button } from "./components/button";

interface PageProps {
  children: React.ReactNode;
}

const NewPage: React.FC<PageProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const { t } = useTranslation();

  const navItems = [
    { label: t("components.page.navItems.useCases"), url: "use-cases" },
    { label: t("components.page.navItems.app"), url: "app" },
    { label: t("components.page.navItems.dashboard"), url: "dashboard" },
    { label: t("components.page.navItems.kit"), url: "kit" },
    { label: t("components.page.navItems.marketplace"), url: "marketplace" },
    { label: t("components.page.navItems.pricing"), url: "pricing" },
  ];

  return (
    <>
      <div className="relative min-h-screen overflow-x-hidden">
        {/* Gradient Background */}
        <div className="absolute top-0 left-0 right-0 h-[800px] -z-20 bg-gradient-to-br from-indigo-400 via-purple-500 to-indigo-600 opacity-90" />

        {/* White Background Below Everything */}
        <div className="absolute inset-0 -z-30 bg-white" />

        {/* Diagonal White Overlay */}
        <div className="absolute top-0 left-0 right-0 h-[800px] -z-10">
          <div className="absolute top-0 left-0 right-0 h-full bg-white transform -skew-y-6 origin-top-left translate-y-[30%]" />
        </div>

        {/* Dashed Lines */}
        {/* {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="hidden lg:block absolute top-0 bottom-0"
            style={{
              left: `${(index + 1) * 16.67}%`,
              width: "1px",
              borderRight: "1px dashed rgba(0, 0, 0, 0.1)",
              zIndex: 0,
            }}
          />
        ))} */}

        {/* Actual Content */}
        <div className="relative z-10 flex flex-col min-h-screen">
          <Navbar />

          <main className="flex-1">{children}</main>
          <div className="z-30">
            <Footer />
          </div>
        </div>

        {/* Dialog Overlay */}
        <Dialog
          open={menuOpen}
          onClose={setMenuOpen}
          style={{
            zIndex: 100,
            position: "absolute",
          }}
        >
          <DialogBody>
            {navItems.map(({ label, url }) => (
              <p
                key={label}
                onClick={() => {
                  setMenuOpen(false);
                  navigate("/" + url);
                }}
                className={
                  "py-2 px-4 my-4 text-lg font-bold rounded-full cursor-pointer " +
                  (location.pathname.split("/")[1] === url ? "bg-zinc-200" : "")
                }
              >
                {label}
              </p>
            ))}
          </DialogBody>
          <DialogActions>
            <Button onClick={() => setMenuOpen(false)}>
              {t("components.page.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default NewPage;
